import React from 'react';

const TelegramAd = () => {
  return (
    <div className="mt-4 animate-fade-in-up">
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-3 md:p-4 text-white relative overflow-hidden">
        {/* Декоративные элементы */}
        <div className="absolute top-0 right-0 w-16 h-16 bg-white opacity-10 rounded-full -translate-y-8 translate-x-8"></div>
        
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex-shrink-0">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-bold text-white mb-1 leading-tight">
                🚀 Управляйте подписками через Telegram
              </h3>
              <p className="text-xs md:text-sm text-blue-100 leading-relaxed">
                <strong>@vless_helperz_bot</strong> • Покупка • Бонусы • Промокоды • Поддержка
              </p>
            </div>
          </div>
          
          {/* Промокод ОСЕНЬ77 */}
          <div className="bg-white bg-opacity-20 rounded-md p-2 mb-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-orange-300">🍂</span>
                <span className="text-xs font-medium text-white">Осенняя скидка -35%</span>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-xs text-blue-100">Промокод:</span>
                <span className="font-bold bg-white text-orange-600 px-1.5 py-0.5 rounded text-xs">ОСЕНЬ77</span>
              </div>
            </div>
            <div className="mt-1 text-xs text-blue-100">
              Продление со скидкой • Новая подписка • Дополнительные бонусы • До 30 ноября
            </div>
          </div>
          
          <div className="flex gap-2">
            <a
              href="https://t.me/vless_helperz_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 inline-flex items-center justify-center px-3 py-1.5 bg-white text-blue-600 rounded-md text-xs font-bold hover:bg-blue-50 transition-colors"
            >
              <svg className="w-3 h-3 mr-1.5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
              </svg>
              Бот
            </a>
            <a
              href="https://t.me/vless_support_plus"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 inline-flex items-center justify-center px-3 py-1.5 bg-blue-600 text-white rounded-md text-xs font-bold hover:bg-blue-700 transition-colors"
            >
              <svg className="w-3 h-3 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z" />
              </svg>
              Поддержка
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelegramAd;
